/*
 * @Author: your name
 * @Date: 2021-11-24 10:48:57
 * @LastEditTime: 2021-11-24 10:52:15
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/store/module/demand/index.js
 */
import actions from './action'
import mutations from './mutation'
const state = {
  searchDemandList: [],
}
const getters = {
  searchDemandList: () => state.searchDemandList
}
export default {
  state,
  getters,
  actions,
  mutations
}